import { functionsURL } from './firebase';

// get the stripe client ID from the webpack env variable
const STRIPE_CONNECT_CLIENT_ID = process.env.STRIPE_CONNECT_CLIENT_ID;

/**
 * URL to begin Stripe Connect onboarding
 * docs: https://stripe.com/docs/connect/standard-accounts#integrating-oauth
 */
// tslint:disable-next-line
export const CONNECT_ONBOARDING_URL = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${STRIPE_CONNECT_CLIENT_ID}&scope=read_write`;

/**
 * URL called when the charity admin completes the Stripe Connect onboarding.
 * This URL must be registered in the Stripe Connect Dashboard: https://dashboard.stripe.com/account/applications/settings
 *
 * The URL is called by Stripe with result parameters:
 *
 *   `on success: .../oauth-callback?scope=read_write&code={AUTHORIZATION_CODE}`
 *
 *   `on cancel/failure: .../oauth-callback?error=access_denied&error_description=The%20user%20denied%20your%20request`
 */
export const OAUTH_CALLBACK_URL = `${functionsURL}/profile/oauth-callback`;
